module.exports = __webpack_public_path__ + "static/media/39_Marketing_Cell.7c0d49b7.JPG";